import { type AsyncStateObject, type Action } from '../../../interfaces'
import { type CoachList } from '../../../interfaces/coachList'
import { APP_ACTION_STATUS, COACH_LIST_ACTIONS, COMMON_ACTIONS } from '../../../utils/constants'
const INITIAL_STATE: AsyncStateObject<CoachList[]> = {
  data: [],
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}
const sessionCoachListReducer = (
  state = INITIAL_STATE,
  action: Action<CoachList[]>
): AsyncStateObject<CoachList[]> => {
  switch (action.type) {
    case COACH_LIST_ACTIONS.GET_SESSION_COACH_LIST + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case COACH_LIST_ACTIONS.GET_SESSION_COACH_LIST + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case COACH_LIST_ACTIONS.GET_SESSION_COACH_LIST + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: [],
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case COACH_LIST_ACTIONS.GET_SESSION_COACH_LIST + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}
export default sessionCoachListReducer
